import React, { useMemo, useState } from 'react'
import { Text, useWindowDimensions, View } from 'react-native'
import InfoPopupModal from '../../../components/infoPopupModal';
import CustomPressable from '../../../components/customPressable/customPressable';
import { useCssStyle } from '../../../customHook/getCssStyle';
import { useTranslation } from 'react-i18next';
import RenderHTML from 'react-native-render-html';
import { ImageComp } from '../../../components/Image/Image';
import { CHEVRON_RIGHT } from '../../../assets';

const ReservationsAskDailyProgram = (props) => {
    const { askDailyProgramAckAvailability, updateAskDailyProgramAckAvailability, handleNext, handleGoBack } = props;

    const getStyles = useCssStyle();
    const { t } = useTranslation();
    const { width } = useWindowDimensions();

    const [selectedDailyProgram, setSelectedDailyProgram] = useState();

    const child_policy = useMemo(() => {
        const style = getStyles(['sevenRoomsDailyProgramAck_itemContainer_childPolicy']);
        return Array.isArray(style) ? Object.assign({}, ...style) : style || {};

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const spend_policy = useMemo(() => {
        const style = getStyles(['sevenRoomsDailyProgramAck_itemContainer_spend_policy']);
        return Array.isArray(style) ? Object.assign({}, ...style) : style || {};

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const table_holding_policy = useMemo(() => {
        const style = getStyles(['sevenRoomsDailyProgramAck_itemContainer_table_holding_policy']);
        return Array.isArray(style) ? Object.assign({}, ...style) : style || {};

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const cuisine = useMemo(() => {
        const style = getStyles(['sevenRoomsDailyProgramAck_itemContainer_cuisine']);
        return Array.isArray(style) ? Object.assign({}, ...style) : style || {};

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const dress_code = useMemo(() => {
        const style = getStyles(['sevenRoomsDailyProgramAck_itemContainer_dress_code']);
        return Array.isArray(style) ? Object.assign({}, ...style) : style || {};

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const price_point = useMemo(() => {
        const style = getStyles(['sevenRoomsDailyProgramAck_itemContainer_price_point']);
        return Array.isArray(style) ? Object.assign({}, ...style) : style || {};

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    return (
        <InfoPopupModal
            title={selectedDailyProgram ? selectedDailyProgram?.title : t('resReservationV2.dailyProgramAck.heading1')}
            subtitle={selectedDailyProgram ? selectedDailyProgram?.description : ""}
            onContinue={selectedDailyProgram ? null : handleNext}
            primaryBtnLabel={selectedDailyProgram ? null : t('resReservationV2.proceed')} 
            onClose={selectedDailyProgram ? () => setSelectedDailyProgram(null) : () => updateAskDailyProgramAckAvailability(false)}
            secondaryBtnLabel={selectedDailyProgram ? t('resReservationV2.back') : t('resReservationV2.close')}
            OnRequestClose={() => updateAskDailyProgramAckAvailability(false)}
        >
            <View style={getStyles(["sevenRoomsDailyProgramAck_MainContainer"])} id='sevenRoomsDailyProgramAck_MainContainer'>
                {
                    selectedDailyProgram ? <>
                        {selectedDailyProgram?.child_policy && <View style={getStyles(['textContainer'])}>
                            <Text style={getStyles(['label'])}>{t('resReservationV2.dailyProgramAck.child_policy')}</Text>
                            <RenderHTML
                                contentWidth={width}
                                baseStyle={child_policy}
                                source={{ html: selectedDailyProgram?.child_policy}}
                                systemFonts={[child_policy.fontFamily]}
                                id={`sevenRoomsDailyProgramAck_itemContainer_childPolicy`}
                            />
                        </View>}

                        {selectedDailyProgram?.spend_policy && <View style={getStyles(['textContainer'])}>
                            <Text style={getStyles(['label'])}>{t('resReservationV2.dailyProgramAck.spend_policy')}</Text>
                            <RenderHTML
                                contentWidth={width}
                                baseStyle={spend_policy}
                                source={{ html: selectedDailyProgram?.spend_policy}}
                                systemFonts={[spend_policy.fontFamily]}
                                id={`sevenRoomsDailyProgramAck_itemContainer_spend_policy`}
                            />
                        </View>}

                        {selectedDailyProgram?.table_holding_policy && <View style={getStyles(['textContainer'])}>
                            <Text style={getStyles(['label'])}>{t('resReservationV2.dailyProgramAck.table_holding_policy')}</Text>
                            <RenderHTML
                                contentWidth={width}
                                baseStyle={table_holding_policy}
                                source={{ html: selectedDailyProgram?.table_holding_policy}}
                                systemFonts={[table_holding_policy.fontFamily]}
                                id={`sevenRoomsDailyProgramAck_itemContainer_table_holding_policy`}
                            />
                        </View>}

                        {selectedDailyProgram?.cuisine && <View style={getStyles(['textContainer'])}>
                            <Text style={getStyles(['label'])}>{t('resReservationV2.dailyProgramAck.cuisine')}</Text>
                            <RenderHTML
                                contentWidth={width}
                                baseStyle={cuisine}
                                source={{ html: selectedDailyProgram?.cuisine}}
                                systemFonts={[cuisine.fontFamily]}
                                id={`sevenRoomsDailyProgramAck_itemContainer_cuisine`}
                            />
                        </View>}
                        {selectedDailyProgram?.dress_code && <View style={getStyles(['textContainer'])}>
                            <Text style={getStyles(['label'])}>{t('resReservationV2.dailyProgramAck.dress_code')}</Text>
                            <RenderHTML
                                contentWidth={width}
                                baseStyle={dress_code}
                                source={{ html: selectedDailyProgram?.dress_code}}
                                systemFonts={[dress_code.fontFamily]}
                                id={`sevenRoomsDailyProgramAck_itemContainer_dress_code`}
                            />
                        </View>}
                        {selectedDailyProgram?.price_point && <View style={getStyles(['textContainer'])}>
                            <Text style={getStyles(['label'])}>{t('resReservationV2.dailyProgramAck.price_point')}</Text>
                            <RenderHTML
                                contentWidth={width}
                                baseStyle={price_point}
                                source={{ html: selectedDailyProgram?.price_point}}
                                systemFonts={[price_point.fontFamily]}
                                id={`sevenRoomsDailyProgramAck_itemContainer_price_point`}
                            />
                        </View>}
                    </>
                    : <>
                        {askDailyProgramAckAvailability?.data?.map((dailyProgramme) => {
                            return (
                                <CustomPressable id={`list_itemContainer sevenRoomsDailyProgramAck_itemContainer`} style={getStyles(['list_itemContainer', 'sevenRoomsDailyProgramAck_itemContainer'])} onPress={() => setSelectedDailyProgram(dailyProgramme)}>

                                    <View id='list_itemContainer_textContainer sevenRoomsDailyProgramAck_itemContainer_textContainer' style={getStyles(['list_itemContainer_textContainer', 'sevenRoomsDailyProgramAck_itemContainer_textContainer'])}>

                                        {dailyProgramme?.title && <Text id='list_itemContainer_textContainer_title sevenRoomsDailyProgramAck_itemContainer_textContainer_title' style={getStyles(['list_itemContainer_textContainer_title', 'sevenRoomsDailyProgramAck_itemContainer_textContainer_title'])}>{dailyProgramme.title} {dailyProgramme?.price_point || ""}</Text>}
                                    
                                        {dailyProgramme?.description && 
                                            <Text 
                                                id='list_itemContainer_textContainer_subtitle sevenRoomsDailyProgramAck_itemContainer_textContainer_subtitle' 
                                                style={getStyles(['list_itemContainer_textContainer_subtitle', 'sevenRoomsDailyProgramAck_itemContainer_textContainer_subtitle'])} 
                                                numberOfLines={3} 
                                                ellipsizeMode="tail"
                                            >
                                                {dailyProgramme.description}
                                            </Text>}
                                    </View>
                                    <View id='list_itemContainer_arrow sevenRoomsDailyProgramAck_itemContainer_arrow' style={getStyles(['list_itemContainer_arrow', 'sevenRoomsDailyProgramAck_itemContainer_arrow'])}>
                                        <ImageComp 
                                            source={CHEVRON_RIGHT} 
                                            style={getStyles(['list_itemContainer_arrow_img', 'sevenRoomsDailyProgramAck_itemContainer_arrow_img'])}
                                            id={`list_itemContainer_arrow_img sevenRoomsDailyProgramAck_itemContainer_arrow_img`}
                                        />
                                    </View>

                                </CustomPressable>
                            )
                        })}
                        <Text style={getStyles(["sevenRoomsDailyProgramAck_question"])} id="sevenRoomsDailyProgramAck_question">{askDailyProgramAckAvailability?.data?.length == 1 ? t('resReservationV2.dailyProgramAck.single_program_ack_question') : t('resReservationV2.dailyProgramAck.multi_program_ack_question')}</Text>
                    </>
                }
            </View>

        </InfoPopupModal>
    )
}

export default ReservationsAskDailyProgram
